import { render, staticRenderFns } from "./Subheading.vue?vue&type=template&id=2dadeed0&functional=true"
import script from "./Subheading.vue?vue&type=script&lang=js"
export * from "./Subheading.vue?vue&type=script&lang=js"
import style0 from "./Subheading.vue?vue&type=style&index=0&id=2dadeed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports